module.exports = __webpack_public_path__ + "static/media/switch-camera.9c45a307.png";